import { Injectable } from '@angular/core';
import { SyncMortgagePackage } from '@models/mortgages/closer-sync-mortgage-packages';
import { State } from '@ngxs/store';
import { CollectionPaths } from '@models/collections';
import { FirestoreStateBaseForBusinessWithSubscription } from '@state/FirestoreStateBaseForBusiness';
import { DEFAULT_STATE_BASE } from '@state/FirestoreStateBase';

export interface SyncMortgagesPackagesStateModel {
	data: SyncMortgagePackage[];
}

const DEFAULT_STATE: SyncMortgagesPackagesStateModel = {
	...DEFAULT_STATE_BASE,
	data: [],
};

@State<SyncMortgagesPackagesStateModel>({
	name: 'syncMortgagesPackages',
	defaults: DEFAULT_STATE,
})
@Injectable()
export class SyncMortgagesPackagesState extends FirestoreStateBaseForBusinessWithSubscription<
	SyncMortgagePackage,
	SyncMortgagesPackagesStateModel
> {
	constructor() {
		super(
			(pathParams) =>
				CollectionPaths.business_syncMortgagePackage(pathParams.businessId),
			(doc) => ({ data: doc as SyncMortgagePackage[] }),
			() => DEFAULT_STATE,
		);
	}
}
